module.exports = __webpack_public_path__ + "img/border.65391183.svg";